import React, { useState, useEffect, useRef } from "react";

const EventFilterDropdown = ({
  eventList,
  selectedEvents,
  setSelectedEvents,
  didCount,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle the dropdown menu visibility
  const toggleDropdown = () => setIsOpen((prev) => !prev);

  // Close dropdown when clicking outside of it
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle checkbox selection
  const handleCheckboxChange = (event) => {
    const value = event;
    if (selectedEvents.includes(value)) {
      setSelectedEvents(selectedEvents.filter((e) => e !== value));
    } else {
      setSelectedEvents([...selectedEvents, value]);
    }
  };

  return (
    <div ref={dropdownRef} className="relative inline-block w-60 text-left">
      <div>
        <button
          type="button"
          onClick={toggleDropdown}
          className="inline-flex w-full justify-between rounded-md bg-lightPrimary px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-navy-900"
        >
          {selectedEvents.length > 0
            ? `${selectedEvents.length} selected`
            : "Events List"}
          <svg
            className="-mr-1 ml-2 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.292 7.707a1 1 0 011.414 0L10 11.002l3.293-3.295a1 1 0 011.414 1.414l-4 4a 1 1 0 01-1.414 0l-4-4a 1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="ring-black absolute z-50 mt-2 w-full origin-top-right rounded-md bg-lightPrimary shadow-lg ring-1 ring-opacity-5 dark:bg-navy-900">
          <div className="py-1">
            {eventList.map((event, index) => (
              <label
                key={index}
                className="flex cursor-pointer items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-navy-800"
              >
                <input
                  type="checkbox"
                  value={event.eventName}
                  checked={selectedEvents.includes(event.eventName)}
                  onChange={() => handleCheckboxChange(event.eventName)}
                  className="form-checkbox h-4 w-4 text-indigo-600"
                />
                <span className="ml-2">{event.eventName}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(EventFilterDropdown);
